module.exports = __webpack_public_path__ + "MaterialIcons-Regular.woff";


//////////////////
// WEBPACK FOOTER
// ./~/material-design-icons/iconfont/MaterialIcons-Regular.woff
// module id = 86
// module chunks = 0